import React from 'react';

const CompaniesIcon = (props) => {
  let { 
    height, 
    width, 
    iconColor,
  } = props;
    
  return (
    <svg 
      width={width ? width :'21px'}
      height={height ? height : '19px'}
      viewBox="0 0 21 19" 
      version="1.1" 
      xmlns="http://www.w3.org/2000/svg" 
      xmlnsXlink="http://www.w3.org/1999/xlink">
      <title>Companies</title>
      <g id="V.4-Design-Change" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="company-filter--copy-2" transform="translate(-975.000000, -31.000000)" fillRule="nonzero" fill={iconColor}>
              <path d="M994.619565,34.3043478 L989.043478,34.3043478 L989.043478,32.0326087 C989.043478,31.4626087 
                988.58087,31 988.01087,31 L982.641304,31 C982.071304,31 981.608696,31.4626087 981.608696,32.0326087 
                L981.608696,34.3043478 L976.032609,34.3043478 C975.462609,34.3043478 975,34.7669565 975,35.3369565 
                L975,48.9673913 C975,49.5373913 975.462609,50 976.032609,50 L994.619565,50 C995.189565,50 
                995.652174,49.5373913 995.652174,48.9673913 L995.652174,35.3369565 C995.652174,34.7669565 
                995.189565,34.3043478 994.619565,34.3043478 Z M982.434783,32.0326087 C982.434783,31.9169565 
                982.525652,31.826087 982.641304,31.826087 L988.01087,31.826087 C988.126522,31.826087 
                988.217391,31.9169565 988.217391,32.0326087 L988.217391,34.3043478 L982.434783,34.3043478 
                L982.434783,32.0326087 Z M994.826087,48.9673913 C994.826087,49.0830435 994.735217,49.173913 
                994.619565,49.173913 L976.032609,49.173913 C975.916957,49.173913 975.826087,49.0830435 
                975.826087,48.9673913 L975.826087,42.5652174 L983.26087,42.5652174 L983.26087,43.8043478 
                C983.26087,44.0356522 983.442609,44.2173913 983.673913,44.2173913 L986.978261,44.2173913 
                C987.209565,44.2173913 987.391304,44.0356522 987.391304,43.8043478 L987.391304,42.5652174 
                L994.826087,42.5652174 L994.826087,48.9673913 Z M984.086957,43.3913043 L984.086957,40.9130435 
                L986.565217,40.9130435 L986.565217,43.3913043 L984.086957,43.3913043 Z M994.826087,41.7391304 
                L987.391304,41.7391304 L987.391304,40.5 C987.391304,40.2686957 987.209565,40.0869565 
                986.978261,40.0869565 L983.673913,40.0869565 C983.442609,40.0869565 983.26087,40.2686957 
                983.26087,40.5 L983.26087,41.7391304 L975.826087,41.7391304 L975.826087,35.3369565 
                C975.826087,35.2213043 975.916957,35.1304348 976.032609,35.1304348 L994.619565,35.1304348 
                C994.735217,35.1304348 994.826087,35.2213043 994.826087,35.3369565 L994.826087,41.7391304 Z" 
                id="Work_Briefcase"></path>
          </g>
      </g>
    </svg>
  );
};

export default CompaniesIcon;



// WEBPACK FOOTER //
// ./src/components/Iconoclast/CompaniesIcon/index.js